import script from "./CharaPublicProfileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CharaPublicProfileCard.vue?vue&type=script&setup=true&lang=js"

import "./CharaPublicProfileCard.vue?vue&type=style&index=0&id=154e7d7e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154e7d7e"]])

export default __exports__